// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import {
  Modal,
  Form,
  Input,
  Radio,
  DatePicker,
  Select,
  Skeleton,
  Card,
} from "antd";

// --------------------- Import Styles ---------------------
import { layout, Title } from "../styles";

// --------------------- Import Hooks ---------------------
import { useBuscarPostagensById } from "../hooks/useBuscarPostagensById";
// --------------------- Import Uteis ---------------------

// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useBuscarLeadsById } from "../../viewGerenciarPessoas/hooks/useBuscarLeadsById";
import { useBuscarEmpreendimentoById } from "../hooks/useBuscarEmpreendimentoById";
import { useBuscarFonteById } from "../hooks/useBuscarFonteById";
import { useBuscarGrupoById } from "../hooks/useBuscarGrupoById";
import { useBuscarEmpreendimentos } from "../../ViewGerenciarPropriedadeUsuario/hooks/useBuscarEmpreendimentos";
import { useBuscarFonte } from "../hooks/useBuscarFonte";
import { useCadastrarPostagem } from "../hooks/useCadastrarPostagem";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { useCopiarPostagem } from "../hooks/useCopiarPostagem";

export default function ModalCopiar({
  isModalOpen,
  handleFechar,
  postagemId,
  fetch,
}: any) {
  const [formPostagem] = Form.useForm();

  // Chamada da função de atualização

  const {
    duplicar,
    isLoading: isLoadingCopia,
    error,
    success,
    resetError,
    resetSuccess,
    warning,
    resetWarning,
  } = useCopiarPostagem();

  const { postagem, isLoading: isLoadingPostagem } = useBuscarPostagensById(
    postagemId,
    isModalOpen
  );

  const {
    isLoading: isLoadingEmpreendimento,
    empreendimento: empreendimentos,
  } = useBuscarEmpreendimentos(isModalOpen);

  const { leads, isLoading: isLoadingLeads } = useBuscarLeadsById(
    postagem?.idLeads,
    isModalOpen
  );
  const { empreendimento } = useBuscarEmpreendimentoById(
    postagem?.idEmpreendimento,
    isModalOpen
  );
  const { fonte } = useBuscarFonteById(postagem?.idFonte, isModalOpen);
  const { grupo } = useBuscarGrupoById(postagem?.idGrupo, isModalOpen);

  const { fontes } = useBuscarFonte(isModalOpen);

  dayjs.extend(customParseFormat);

  const postagemChange = (changedValues: Partial<any>, allValues: any) => {
    setPostagemData((prev: any) => ({
      ...prev,
      ...changedValues, // só os campos que realmente mudaram
    }));
  };

  const { showSuccess, showWarning, showError, contextHolder } = useMessage();

  // Estado inicial de dos dados Postagem que serão atualizados
  const [postagemData, setPostagemData] = useState<any>({});

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  useEffect(() => {
    // Exibe a mensagem de sucesso
    if (success && !successDisplayed) {
      const msgSuccess = "Postagem copiada com sucesso!";
      showSuccess(msgSuccess);
      setSuccessDisplayed(true);
      fetch?.();
      handleFechar();
      formPostagem.resetFields();
      setTimeout(() => {
        resetSuccess();
        setSuccessDisplayed(false);
      }, 3000);
    }
    if (error && !errorDisplayed) {
      const msgError = "Não foi possível copiar a postagem! Tente Novamente!";
      showError(msgError);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
    if (warning && !warningDisplayed) {
      showWarning(warning);
      setWarningDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setWarningDisplayed(false);
        resetWarning();
      }, 3000);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    resetSuccess,
    errorDisplayed,
    successDisplayed,
    resetError,
    warning,
    resetWarning,
    warningDisplayed,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  useEffect(() => {
    if (!formPostagem) {
      return;
    }
    formPostagem.setFieldsValue({
      idLeads: leads?.id,
      idEmpreendimento: empreendimento?.id,
      idFonte: fonte?.nome,
      idGrupo: grupo?.nome,
      active: postagem?.active,
      dataDivulgacao: postagem?.dataDivulgacao
        ? dayjs(postagem?.dataDivulgacao)
        : null,
      tipoInteresse: postagem?.tipoInteresse,
      troca: postagem?.troca,
      aluguel: postagem?.aluguel,
      compra: postagem?.compra,
      venda: postagem?.venda,
      dataIni: postagem?.dataIni ? dayjs(postagem?.dataIni) : null,
      dataFim: postagem?.dataFim ? dayjs(postagem?.dataFim) : null,
    });

    setPostagemData({
      idLeads: leads?.id,
      idEmpreendimento: empreendimento?.id,
      idFonte: fonte?.nome,
      idGrupo: grupo?.nome,
      active: postagem?.active,
      dataDivulgacao: postagem?.dataDivulgacao
        ? dayjs(postagem?.dataDivulgacao)
        : null,
      tipoInteresse: postagem?.tipoInteresse,
      troca: postagem?.troca,
      aluguel: postagem?.aluguel,
      compra: postagem?.compra,
      venda: postagem?.venda,
      dataIni: postagem?.dataIni ? dayjs(postagem?.dataIni) : null,
      dataFim: postagem?.dataFim ? dayjs(postagem?.dataFim) : null,
    });
  }, [formPostagem, postagem, leads, empreendimento, fonte, grupo]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Copiar"
        onOk={() => duplicar(postagemData)}
        confirmLoading={isLoadingCopia}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoadingEmpreendimento &&
          isLoadingEmpreendimento &&
          isLoadingLeads && <Skeleton />}
        {!isLoadingPostagem && !isLoadingEmpreendimento && !isLoadingLeads && (
          <Card
            title={<Title>Copiar</Title>}
            style={{
              width: "100%",
              marginTop: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <>{contextHolder}</>
            <Form
              {...layout}
              form={formPostagem}
              name="postagem"
              onValuesChange={(changedValues, allValues) =>
                postagemChange(changedValues, allValues)
              }
              validateMessages={validarFormulario}
            >
              <Form.Item
                name={["idEmpreendimento"]}
                label="Empreendimento "
                className="formItems"
              >
                <Select placeholder="Empreendimento">
                  {empreendimentos.map((emp) => (
                    <Select.Option key={emp.id} value={emp.id}>
                      {emp.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["idFonte"]}
                label="Fonte "
                className="formItems"
              >
                <Select placeholder="Fonte">
                  {fontes.map((fonte: any) => (
                    <Select.Option key={fonte.id} value={fonte.nome}>
                      {fonte.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["idGrupo"]}
                label="Grupo "
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["dataDivulgacao"]}
                label="Data Divulgação "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["tipoInteresse"]}
                label="Tipo Interesse "
                className="formItems"
              >
                <Radio.Group>
                  <Radio value={"DISPONIBILIZA"}>Disponibiliza</Radio>
                  <Radio value={"PROCURA"}>Procura</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["aluguel"]}
                label="Alugar "
                className="formItems"
              >
                <Radio.Group>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["troca"]} label="Trocar " className="formItems">
                <Radio.Group>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["compra"]}
                label="Compra "
                className="formItems"
              >
                <Radio.Group>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["venda"]} label="Venda " className="formItems">
                <Radio.Group>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["dataIni"]}
                label="Data Inicio "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["dataFim"]}
                label="Data Fim "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Form>
          </Card>
        )}
      </Modal>
    </>
  );
}
